export const headerStyles = {
  width: "100%",
  height: "5rem",
  backgroundColor: "#000",
  boxShadow: "0 .5rem 1.5rem rgba(0, 0, 0, 0.1)",
};

export const searchContainerStyles = {
  display: "flex",
  flexDirection: "row",
  gap: "25px",
  width: "55%",
  justifyContent: "space-between",
  alignItems: "center",
  margin: "auto",
};

export const navigateItemStyles = {
  color: "#fff",
  fontSize: "20px",
  fontWeight: "400",
  cursor: "pointer",
};


export const selectStyles = {
  color: "#fff",
  border: "1px solid #fff",
  "& .MuiSelect-icon": {
    color: "#fff",
  },
}